<script setup lang="ts">
defineProps({
  size: {
    type: String as () => '50' | '44' | '32',
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})
</script>

<template>
  <button
    type="button"
    class="rounded-12 text-button-semibold enabled:hover:shadow-button disabled:bg-black-300 disabled:text-black-700 flex w-full select-none flex-row items-center justify-center outline-none transition-all enabled:active:shadow-none disabled:cursor-not-allowed"
    :class="{
      'h-32': size === '32',
      'h-44': size === '44',
      'h-[50px]': size === '50',
    }"
    :disabled="disabled"
  >
    <slot />
  </button>
</template>
